<template>
  <div class="page-content">
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="d-flex">
              <el-date-picker
                v-model="search.date_range"
                type="daterange"
                size="small"
                :picker-options="date_picker_options"
                @change="dateCheck"
                range-separator="To"
                start-placeholder="Start date"
                end-placeholder="End date">
              </el-date-picker> &nbsp;
              <el-select size="small" @input="handleInputStatusFilter" v-model="status_filter" multiple placeholder="Select">
                <el-option
                  v-for="item in statusFilterOptions"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value">
                </el-option>
              </el-select> &nbsp;
              <el-select v-model="dateFilterType" size="small">
                <el-option v-for="(item, i) in dateFilterTypeOptions" :key="i" :value="item.value" :label="item.text" />
              </el-select> &nbsp;
              <el-button :loading="loading.table" @click="page = 1; getList();" size="small" class="btn-default" icon="el-icon-search">Search</el-button>
              <!-- <el-button :loading="loading.table" @click="downloadReport();" size="small" class="btn-primary" icon="el-icon-position">Send to Email</el-button> -->
              <el-button :loading="loading.table" @click="downloadReport();" size="small" class="btn-primary" icon="el-icon-download">Download</el-button>
            </div>
            <hr/>
            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>Ticket No</th>
                    <th>Status</th>
                    <th>Customer Name</th>
                    <th>Customer Phone</th>
                    <th>Started At</th>
                    <th>Resolved At</th>
                    <th>Duration</th>
                    <th>Channel</th>
                    <th>Agent Name</th>
                    <th>Group</th>
                    <th>First Response Date</th>
                    <th>First Response Time</th>
                    <th>Labels</th>
                    <th>CSAT Rating</th>
                    <th>CSAT Comment</th>
                    <th>Source of Fund</th>
                    <th>Price</th>
                    <th>Reference Number</th>
                    <th>SLA First Response</th>
                    <th>Status SLA First Response</th>
                    <th>SLA Resolution</th>
                    <th>Status SLA Resolution</th>
                  </tr>
                </thead>
                <tbody v-loading="loading.table">
                  <tr v-for="(item, i) in reportList" :key="i" @click="manage(workspace)" style="cursor: pointer">
                    <td>#{{ item.code }}</td>
                    <td>
                      <span style="padding: 6px" class="badge ml-1" :class="item.status_color_str">{{ upperFirst(item.status) }}</span>
                    </td>
                    <td>
                      {{ isChatPrivacy(item.contacts[0].name) }}
                    </td>
                    <td>
                      {{ item.whatsapp_contact ? isChatPrivacy(item.whatsapp_contact.phone_number || item.whatsapp_contact.user_id) : isChatPrivacy(item.contacts[0].phone_number || item.contacts[0].user_id) }}
                    </td>
                    <td>
                      {{ formatDate(item.opened_at) }}
                    </td>
                    <td>
                      {{ formatDate(item.resolved_at) }}
                    </td>
                    <td>
                      {{ countDuration(item.opened_at, item.resolved_at) }}
                    </td>
                    <td class="text-capitalize">
                      {{ item.channels_used.join(', ') }}
                    </td>
                    <td>
                      {{ item.agent.user ? item.agent.user.name : '-' }}
                    </td>
                    <td>
                      {{ item.agent_group ? item.agent_group.name : '-' }}
                    </td>
                    <td>
                      {{ item.handling_at ? formatDate(item.handling_at) : '-' }}
                    </td>
                    <td>
                      {{ item.handling_at ? countDuration(item.opened_at, item.handling_at) : '-' }}
                    </td>
                    <td>
                      <el-tag size="mini" v-for="(l) in item.labels" :key="l.id" :style="{ 'background-color': l.color, 'color': 'white' }" class="mr-1">
                        {{ l.title }}
                      </el-tag>
                    </td>
                    <td>
                      <span v-if="item.rating && item.rating.rate_value">
                        <font-awesome style="color: #D4AF37" icon="star" v-for="i in item?.rating.rate_value" :key="i"/>
                        <font-awesome :icon="['far', 'star']" v-for="i in (5 - item?.rating.rate_value)" :key="i"/>
                        {{ item.rating?.rate_value }} / 5
                      </span>
                      <span v-else>-</span>
                    </td>
                    <td>
                      <span v-if="item.rating && item.rating.rate_value">
                        {{ item.rating.comment || '-' }}
                      </span>
                      <span v-else>-</span>
                    </td>
                    <td>{{ item.source_of_fund_str || '-' }}</td>
                    <td>{{ item.price || '-' }}</td>
                    <td>{{ item.reference_number || '-' }}</td>
                    <td>
                      <template v-if="custom_feature?.sla?.status && item.opened_at">
                        <p>
                          {{ getSlaTimeResponseDeadline(item.opened_at, custom_feature.sla.settings.ticket.first_time_response) }}
                        </p>
                      </template>
                      <template v-else>
                        -
                      </template>
                    </td>
                    <td>
                      <template v-if="custom_feature?.sla?.status && item.opened_at && (item.handling_at || item.resolved_at)">
                        <el-tag
                          class="mr-2"
                          size="mini"
                          :type="isOverdueFirstTimeResponse(item, custom_feature.sla.settings.ticket.first_time_response) ? 'danger' : 'success'"
                        >
                          {{ isOverdueFirstTimeResponse(item, custom_feature.sla.settings.ticket.first_time_response) ? 'Overdue' : 'OK' }}
                        </el-tag>
                      </template>
                      <template v-else>
                        -
                      </template>
                    </td>
                    <td>
                      <template v-if="custom_feature?.sla?.status && item.opened_at">
                        <p class="mr-2" size="mini">
                          {{ getSlaTimeResponseDeadline(item.opened_at, custom_feature.sla.settings.ticket.resolution_time) }}
                        </p>
                      </template>
                      <template v-else>
                        -
                      </template>
                    </td>
                    <td>
                      <template v-if="custom_feature?.sla?.status && item.opened_at && (item.resolved_at || item.handling_at)">
                        <el-tag
                          class="mr-2"
                          size="mini"
                          :type="isOverdueResolutionTime(item, custom_feature.sla.settings.ticket.resolution_time) ? 'danger' : 'success'"
                        >
                          {{ isOverdueResolutionTime(item, custom_feature.sla.settings.ticket.resolution_time) ? 'Overdue' : 'OK' }}
                        </el-tag>
                      </template>
                      <template v-else>
                        -
                      </template>
                    </td>
                  </tr>
                </tbody>
              </table>
              <el-empty v-if="totalRow == 0" description="No data"></el-empty>
            </div>
            <b-pagination v-if="totalRow > page_limit" v-model="currentPage" :total-rows="totalRow" :per-page="page_limit"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  isEmpty, upperFirst, difference, isMatch,
} from 'lodash';
import moment from 'moment';
import humanizeDuration from 'humanize-duration';
import reportApi from '../../../api/reports';
import popupErrorMessages from '../../../library/popup-error-messages';
import customFeatures from '../../../api/customFeatures';

export default {
  beforeCreate() {
    this.moment = moment;
    this.humanizeDuration = humanizeDuration;
  },
  name: 'HelpdeskReports',
  metaInfo: {
    title: 'Helpdesk Reports',
  },
  data() {
    return {
      upperFirst,
      showModal: false,
      showModalEdit: false,
      page_limit: 50,
      loading: {
        table: false,
        custom_feature: false,
      },
      form: {
        name: '',
        ws_product_id: '',
      },
      dateFilterTypeOptions: [
        {
          value: 'open',
          text: 'Open Date',
        },
        {
          value: 'handling',
          text: 'Handling Date',
        },
        {
          value: 'resolved',
          text: 'Resolved Date',
        },
      ],
      dateFilterType: this.$route.query.date_filter_type || 'resolved',
      status_filter: this.$route.query.status_filter || ['resolved'],
      statusFilterOptions: [
        {
          value: 'all',
          text: 'All',
        },
        {
          value: 'open',
          text: 'Open',
        },
        {
          value: 'handling',
          text: 'Handling',
        },
        {
          value: 'resolved',
          text: 'Resolved',
        },
      ],
      editedId: '',
      reportList: [],
      loaderStack: 0,
      loader: null,
      search: {
        date_range: [
          this.$route.query.start_date || new Date(),
          this.$route.query.end_date || new Date(),
        ],
      },
      page: this.$route.query.page || 1,
      totalRow: 0,
      date_picker_options: {
        disabledDate: (time) => {
          const today = moment();
          const diff = today.diff(moment(time), 'd');
          if (diff > 90 || diff < 0) {
            return true;
          }
          if (diff === 0) {
            if (today.isSame(moment(time), 'd') === false) {
              return true;
            }
          }
          return false;
        },
        shortcuts: [
          {
            text: 'This week',
            onClick(picker) {
              const start = moment().startOf('week').format();
              const end = moment().format();
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: 'This month',
            onClick(picker) {
              const start = moment().startOf('month').format();
              const end = moment().format();
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: 'Last week',
            onClick(picker) {
              const start = moment().subtract(1, 'week').startOf('week').format();
              const end = moment().subtract(1, 'week').endOf('week').format();
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: 'Last month',
            onClick(picker) {
              const start = moment().subtract(1, 'month').startOf('month').format();
              const end = moment().subtract(1, 'month').endOf('month').format();
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      custom_feature: {},
    };
  },
  computed: {
    activeWorkspace() {
      return this.$store.state.workspace.activeWorkspace;
    },
    currentPage: {
      get() {
        return this.page;
      },
      set(val) {
        this.page = val;
        this.getList();
      },
    },
  },
  async mounted() {
    this.showLoader();
    await this.getList();
    await this.getCustomFeature();
    this.hideLoader();
  },
  methods: {
    dateCheck() {
      const [start_date, end_date] = this.search.date_range;
      const minTime = moment(start_date);
      const maxTime = moment(end_date);
      const diff = maxTime.diff(moment(minTime), 'd');
      if (diff > 30) {
        this.$message({
          title: this.$t('general.error.general'),
          type: 'warning',
          message: 'Reporting period that can be selected for 31 days',
          duration: 20 * 100,
          showClose: true,
        });
        this.search.date_range = [start_date, start_date];
      }
    },
    countDuration(start, end) {
      return start && end ? humanizeDuration(moment(start).diff(moment(end)), { largest: 2, round: true }) : '-';
    },
    formatDate(string, format = 'DD MMM YYYY, HH:mm') {
      return string ? moment(string).format(format) : '-';
    },
    showLoader() {
      if (this.loaderStack === 0) {
        this.loader = this.$loading.show();
      }
      this.loaderStack += 1;
    },
    hideLoader() {
      this.loaderStack -= 1;
      if (this.loaderStack === 0) {
        this.loader.hide();
      }
    },
    async downloadReport() {
      this.$confirm(this.$t('report.confirm_download'), this.$t('general.confirmation'), {
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no'),
        type: 'warning',
        center: true,
        /* eslint-disable no-param-reassign */
        beforeClose: async (action, instance, cb) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            this.loading.table = true;
            if (isEmpty(this.search.date_range)) {
              this.search.date_range = [new Date(), new Date()];
            }
            const [start_date, end_date] = this.search.date_range;
            const response = await reportApi.download({
              workspace_id: this.activeWorkspace._id,
              start_date: this.formatDate(start_date, 'YYYY-MM-DD'),
              end_date: this.formatDate(end_date, 'YYYY-MM-DD'),
              date_filter_type: this.dateFilterType,
              status_filter: this.status_filter,
            }).catch(() => {});
            this.loading.table = false;
            instance.confirmButtonLoading = false;
            await popupErrorMessages(response);
            this.$message({
              title: this.$t('general.success'),
              type: 'success',
              message: this.$t('general.waiting_download'),
              duration: 30 * 1000,
              showClose: true,
            });
          }
          cb();
        },
      });
    },
    async getList() {
      if (isEmpty(this.search.date_range)) {
        this.search.date_range = [new Date(), new Date()];
      }
      this.dateCheck();
      const [start_date, end_date] = this.search.date_range;
      const options = {
        page: this.page,
        start_date: this.formatDate(start_date, 'YYYY-MM-DD'),
        end_date: this.formatDate(end_date, 'YYYY-MM-DD'),
        date_filter_type: this.dateFilterType,
        status_filter: this.status_filter,
      };
      if (!isMatch(this.$route.query, options)) {
        this.$router.replace({ query: options });
        return;
      }
      this.loading.table = true;
      const response = await reportApi.getList({
        workspace_id: this.activeWorkspace._id,
        ...options,
      }).catch(() => {});

      this.loading.table = false;
      await popupErrorMessages(response);
      const channel_alias = {
        whatsapp: 'WhatsApp',
      };
      const source_list = {
        postpaid: 'Postpaid',
        balance: 'Balance',
      };
      this.reportList = response.data.rows.map((item) => {
        item.status_color_str = 'badge-danger';
        if (item.status === 'resolved') {
          item.status_color_str = 'badge-success';
        } else if (item.status === 'handling') {
          item.status_color_str = 'badge-primary';
        }
        item.whatsapp_contact = item.contacts.find((v) => v.channel === 'whatsapp');
        item.channels_used = item.channels.map((v) => channel_alias[v] || upperFirst(v));
        item.source_of_fund_str = '-';
        if (item.source_of_fund) {
          item.source_of_fund_str = source_list[item.source_of_fund] || 'Free Ticket Quota';
        }
        return item;
      });
      this.totalRow = response.data.count;
    },
    handleInputStatusFilter(value) {
      if (value[value.length - 1] === 'all') {
        this.status_filter = ['all'];
      } else if (value.indexOf('all') !== -1) {
        this.status_filter.splice(value.indexOf('all'), 1);
      } else if (difference(['open', 'handling', 'resolved'], this.status_filter).length === 0) {
        this.status_filter = ['all'];
      }
    },
    async getCustomFeature() {
      this.loading.custom_feature = true;
      const response = await customFeatures.getCustomFeature(this.activeWorkspace._id);
      this.loading.custom_feature = false;
      await popupErrorMessages(response);
      this.custom_feature = response.data;
    },
    getSlaTimeResponseDeadline(time, sla_time) {
      return moment(time)
        .add(parseInt(sla_time), 'minutes')
        .format('DD MMM YYYY, HH:mm');
    },
    validationStatusSla(time, sla_time) {
      return time > sla_time;
    },
    isOverdueFirstTimeResponse(item, firstTimeResponse) {
      const handling_at = moment(item.handling_at || moment()).seconds(0).milliseconds(0);
      const opened_at = moment(item.opened_at).seconds(0).milliseconds(0);
      const diffInMinutes = handling_at
        .diff(
          opened_at,
          'minutes',
        );
      return this.validationStatusSla(diffInMinutes, firstTimeResponse);
    },
    isOverdueResolutionTime(item, resolutionTime) {
      const resolved_at = moment(item.resolved_at || moment()).seconds(0).milliseconds(0);
      const opened_at = moment(item.opened_at).seconds(0).milliseconds(0);
      const diffInMinutes = resolved_at
        .diff(
          opened_at,
          'minutes',
        );
      return this.validationStatusSla(diffInMinutes, resolutionTime);
    },
    isChatPrivacy(phone_number) {
      if (this.$store.state.auth.userProfile.is_pic !== true && this.$store.state.auth.userProfile.agents && this.$store.state.auth.userProfile.agents[0] && this.activeWorkspace.configuration && this.activeWorkspace.configuration.chat_privasi && this.activeWorkspace.configuration.chat_privasi.masking_phone_number === true) {
        if (phone_number && this.validatePhoneNumber(phone_number)) {
          return `${phone_number.substring(0, 2)}********${phone_number.substring(phone_number.length - 2)}`;
        }
      }
      return phone_number;
    },
    validatePhoneNumber(phone_number) {
      const validateRegex = /^\+?[1-9][0-9]{7,14}$/;
      return validateRegex.test(`+${phone_number}`);
    },
  },
};
</script>
